export const getGroupSubscriptions = (groupId: number) => {
	return {
		url: `loyalty-management/subscription/loyalty?groupId=${groupId}`,
	};
};
